module.exports = __webpack_public_path__ + "res/img_how_works.5dd459253901368e21adca289a578632.png";